export default __webpack_public_path__ + "static/media/background-large-green.6b430d52.png";